<template>
  <div class="skeleton" :class="[`skeleton--${variant}`]">
    <div class="skeleton__shimmer" />
    <div v-if="variant === 'card'" class="skeleton__card-inner">
      <div class="skeleton__block w-12 h-12 rounded-xl" />
      <div class="skeleton__content">
        <div class="skeleton__block w-16 h-6 rounded mb-2" />
        <div class="skeleton__block w-24 h-4 rounded" />
      </div>
    </div>
    <div v-if="variant === 'text'" class="skeleton__block w-full h-4 rounded" />
    <div v-if="variant === 'table-row'" class="skeleton__table-row">
      <div class="skeleton__block flex-1 h-4 rounded" />
      <div class="skeleton__block w-20 h-4 rounded" />
      <div class="skeleton__block w-24 h-4 rounded" />
    </div>
    <!-- Unified table row: 52px height, 14px spacing match -->
    <div v-if="variant === 'table'" class="skeleton__table">
      <div class="skeleton__block skeleton__table-cell flex-1 h-5 rounded" />
      <div class="skeleton__block skeleton__table-cell w-24 h-5 rounded" />
      <div class="skeleton__block skeleton__table-cell w-28 h-5 rounded" />
    </div>
  </div>
</template>

<script setup>
defineProps({
  variant: {
    type: String,
    default: 'card',
    validator: (v) => ['card', 'text', 'table-row', 'table'].includes(v),
  },
});
</script>

<style scoped>
.skeleton {
  @apply relative overflow-hidden rounded-2xl bg-slate-100;
}

.skeleton__shimmer {
  @apply absolute inset-0;
  background: linear-gradient(
    105deg,
    transparent 0%,
    transparent 40%,
    rgba(255, 255, 255, 0.65) 50%,
    transparent 60%,
    transparent 100%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.8s ease-in-out infinite;
}

@keyframes skeleton-shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.skeleton__card-inner {
  @apply flex items-center gap-4 p-5 relative;
}

.skeleton__content {
  @apply flex-1 min-w-0;
}

.skeleton__block {
  @apply bg-slate-200/80 relative;
}

.skeleton__table-row {
  @apply flex gap-4 items-center p-4 relative;
}

.skeleton--table {
  @apply rounded-xl;
}

.skeleton__table {
  @apply flex gap-4 items-center relative;
  min-height: 52px;
  padding: 14px 24px;
}

.skeleton__table-cell {
  @apply flex-shrink-0;
}
</style>
